<template>
  <div class="app-container demo-list">
    <div class="search-wrapper">
      <div class="tab-wrapper">
        <el-button :type="isFocus === 1 ? 'table-top-active' : 'table-top'" size="mini">全部</el-button>
      </div>
      <el-search
        :form-item-data="formItemData"
        :is-show.sync="isShow"
        :span="8"
        @onSubmitSingle="onSubmitSingle"
        @onSubmitMulti="onSubmitMulti">
        <el-button size="mini" type="primary" @click="handleGoNew">新增信息</el-button>
      </el-search>
    </div>
    <div class="multifunctional-table-wrapper">
      <div v-show="popoverShow" class="popover" @click.stop="">
        <el-checkbox
          v-for="(e, i) in fixedTableThead"
          :key="i"
          :checked="e.checked"
          disabled
          class="popover-disabled">{{ e.label }}
        </el-checkbox>
        <div class="popover-line"></div>
        <draggable :list="unfixedTableThead" class="draggable" @change="handleTableChange">
          <el-checkbox-group v-for="(item,index) in unfixedTableThead" v-model="item.checked" :key="index">
            <el-checkbox
              :label="item"
              :checked="item.checked"
              :width="item.width"
              :title="item.label"
              @change="handleUpdate(item, index)">{{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </draggable>
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        :fit="true"
        :row-style="rowClass"
        :cell-style="cellStyle"
        border
        class="multifunctional-table"
        @select-all="handleCheckAllChange"
        @select="handleCheckChange"
        @selection-change="handleSelectionChange"
        @header-dragend="tableTitleWidth"
      >
        <el-table-column type="selection" width="55"/>
        <template v-for="(table, index) in tableTheadOptions">
          <el-table-column
            v-if="table.checked"
            :fixed="table.fixed"
            :key="index"
            :label="table.label"
            :width="table.width"
            :prop="table.prop"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">{{ scope.row[table.prop] }}
            </template>
          </el-table-column>
        </template>

        <el-table-column label="操作" width="130" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="handleGoDetail(scope.$index, scope.row)">查看
            </el-button>
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="handleGoEdit(scope.$index, scope.row)">编辑
            </el-button>
            <el-button
              v-if="true"
              size="mini"
              type="text"
              @click="handleDelete(scope.$index, scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
        <el-table-column :render-header="renderLastHeader" label="set" width="36" fixed="right"/>
      </el-table>
      <div class="table-footer">
        <div v-show="isSelection" class="operation">
          <el-button size="mini" type="default" @click="handleDelSelected">批量删除</el-button>
          <el-button size="mini" type="default" @click="handleExport">导出<i class="el-icon-caret-top"/></el-button>
        </div>
        <div class="paging">
          <el-pagination
            :total="totalNum"
            :page-size="10"
            :current-page="pageNoCode"
            prev-text="< 上一页"
            next-text="下一页 >"
            background
            layout="prev, pager, next, total, jumper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"/>
          <el-button class="pagination-btn" size="mini" type="default" @click="handleSizeChange">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { delList, getList } from '@/api/demo-list'

export default {
  components: {
    draggable
  },
  data () {
    return {
      // 表格数据
      tableData: [],
      // 表格命名
      tableName: this.tableList.tmplDemo1,
      // 表格数据
      tableThead: [],
      // 锁定表格
      fixedTableThead: [
        { label: '序号', prop: 'demoId', width: 70, checked: true, fixed: true }
      ],
      // 非锁定表格
      unfixedTableThead: [
        { label: '名称', prop: 'demoName', width: 'auto', checked: true, fixed: false },
        { label: '用户名', prop: 'userName', width: 'auto', checked: true, fixed: false },
        { label: '年龄', prop: 'age', width: 'auto', checked: true, fixed: false },
        { label: '手机号', prop: 'phone', width: 'auto', checked: true, fixed: false },
        { label: '单价', prop: 'skuPrince', width: 'auto', checked: true, fixed: false },
        { label: '库存量', prop: 'skuNum', width: 'auto', checked: true, fixed: false },
        { label: '创建人ID', prop: 'createUserId', width: 'auto', checked: true, fixed: false },
        { label: '修改人ID', prop: 'modifyUserId', width: 'auto', checked: true, fixed: false },
        { label: '修改人', prop: 'modifyUser', width: 'auto', checked: true, fixed: false },
        { label: '修改时间', prop: 'modifyDate', width: 'auto', checked: true, fixed: false },
        { label: '是否启用', prop: 'status', width: 'auto', checked: true, fixed: false }
      ],
      // 动态表格
      tableTheadOptions: [],
      // 弹框表格
      popoverShow: false,
      selectRow: [],
      selectData: [],
      isFocus: 1,
      isSelection: false,
      totalNum: 0,
      // 高级搜索提交数据
      formData: {},
      // 高级搜索组件数据
      formItemData: [
        {
          id: '1',
          type: 'input',
          placeHolder: '名称',
          name: 'demoName',
          label: '名称：',
          value: '',
          outputValue: ''
        }, {
          id: '2',
          type: 'input',
          placeHolder: '用户名',
          name: 'userName',
          label: '用户名：',
          value: '',
          outputValue: ''
        }, {
          id: '3',
          type: 'input',
          placeHolder: '手机号',
          name: '',
          label: '手机号：',
          value: '',
          outputValue: ''
        }, {
          id: '4',
          type: 'select',
          placeHolder: '库存量',
          name: 'skuNum',
          label: '库存量：',
          value: '',
          outputValue: '',
          option: [
            {
              value: '1',
              label: '10件'
            }, {
              value: '2',
              label: '20件'
            }, {
              value: '3',
              label: '30件'
            }, {
              value: '4',
              label: '40件'
            }
          ]
        }, {
          id: '5',
          type: 'checkbox-group',
          placeHolder: '',
          name: 'type',
          label: '创建人ID：',
          value: '',
          outputValue: '',
          option: [
            {
              value: '1',
              label: '1'
            }, {
              value: '2',
              label: '2'
            }
          ]
        }, {
          id: '6',
          type: 'textarea',
          placeHolder: '修改人',
          name: 'modifyUser',
          label: '修改人：',
          value: '',
          outputValue: ''
        }, {
          id: '7',
          type: 'date-range',
          placeHolder: '修改时间',
          name: 'modifyDate',
          label: '合同日期：',
          value: '',
          outputValue: ''
        }, {
          id: '8',
          type: 'radio-group',
          name: 'region',
          label: '是否启用：',
          value: '',
          outputValue: '',
          option: [
            {
              value: '1',
              label: '是'
            }, {
              value: '2',
              label: '否'
            }
          ]
        }
      ],
      isShow: false,
      isIndeterminate: false,
      checkAll: false,
      pageNoCode: 1
    }
  },
  watch: {
    $route (to, from) {
      // 从不同页面进入list，刷新页面
      if (from.name === 'tmpl-demo-edit-demo' || from.name === 'tmpl-demo-new-demo' || from.name === 'tmpl-demo-demo-detail') {
        console.log('从编辑或添加页面来，需要重新请求')
        this.getList()
      }
    },
    selectData (data) {
      this.selectRow = []
      if (data.length > 0) {
        data.forEach((item, index) => {
          this.selectRow.push(this.tableData.indexOf(item))
        })
      }
    },
    popoverShow (value) {
      const that = this
      if (value) {
        setTimeout(function () {
          document.body.addEventListener('click', that.popoverClose)
        }, 0)
      } else {
        document.body.removeEventListener('click', that.popoverClose)
      }
    }
  },
  created () {
    this.getList()
    this.setTableWidth()
    this.renderTable()
  },
  mounted () {
  },
  activated () {
    this.$store.dispatch('closeSidebarTemporary')
  },
  methods: {
    popoverClose () {
      this.popoverShow = false
    },
    handlePopoverShow (column, event) {
      if (column.label === 'set') {
        this.popoverShow = !this.popoverShow
      }
    },
    // 根据返回状态显示不同的文字颜色
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 8 && row.state === '审批不通过') {
        return 'color:#D5090B;'
      } else if (columnIndex === 8 && row.state === '审批通过') {
        return 'color:#00954C;'
      } else if (columnIndex === 8 && row.state === '待审批') {
        return ''
      }
    },
    // 默认渲染表格
    renderTable () {
      const localTableData = JSON.parse(localStorage.getItem(this.tableName))
      if (localTableData) {
        console.log('有本地表格数据')
        this.tableTheadOptions = localTableData
        this.tableThead = localTableData
        for (let i = 0; i < this.unfixedTableThead.length; i++) {
          this.unfixedTableThead[i].checked = localTableData[i].checked
        }
      } else {
        console.log('无本地表格数据')
        this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead)
        console.log('this.tableThead', this.tableThead)
        // this.tableTheadOptions = this.tableThead
        const comment = JSON.stringify(this.tableThead)
        localStorage.setItem(this.tableName, comment)
        const localTableData = JSON.parse(localStorage.getItem(this.tableName))
        this.tableTheadOptions = localTableData
      }
    },
    // 表格弹框拖拽触发
    handleTableChange (val) {
      console.log('发生改变', val)
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead)
      const comment = JSON.stringify(this.tableThead)
      localStorage.setItem(this.tableName, comment)
      const localTableData = JSON.parse(localStorage.getItem(this.tableName))
      this.tableTheadOptions = localTableData
      // window.location.reload()
    },
    // 是否显示对应列
    handleUpdate (item, index) {
      console.log(44444, item.checked, index)
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (i === index) {
          this.unfixedTableThead.checked = !this.unfixedTableThead.checked
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead)
      const comment = JSON.stringify(this.tableThead)
      localStorage.setItem(this.tableName, comment)
      const localTableData = JSON.parse(localStorage.getItem(this.tableName))
      this.tableTheadOptions = localTableData
    },
    // 渲染本地存储表格宽度
    setTableWidth () {
      const localTableData = JSON.parse(localStorage.getItem(this.tableName))
      if (localTableData) {
        for (let i = 0; i < this.tableTheadOptions.length; i++) {
          if (this.tableTheadOptions[i].label === localTableData[i].label) {
            this.tableTheadOptions[i].width = localTableData[i].width
          }
        }
      }
    },
    // 表格宽度更改存入
    tableTitleWidth (newWidth, oldWidth, column, event) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (this.unfixedTableThead[i].label === column.label) {
          this.unfixedTableThead[i].width = newWidth
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead)
      const comment = JSON.stringify(this.tableThead)
      localStorage.setItem(this.tableName, comment)
      this.tableTheadOptions = JSON.parse(localStorage.getItem(this.tableName))
    },
    handleSelectionChange (data) {
      this.selectData = data
    },
    rowClass ({ row, rowIndex }) {
      if (this.selectRow.includes(rowIndex)) {
        return { 'background-color': 'rgba(255,232,195,1) ' }
      }
    },
    handleGoEdit (index, row) {
      this.$router.push('/tmpl/demo/edit-demo/' + row.demoId)
    },
    handleDelete (index, row) {
      this.delList([row.demoId])
    },
    handleGoDetail (index, row) {
      this.$router.push('/tmpl/demo/demo-detail/' + row.demoId + '/' + row.demoName)
    },

    handleGoNew () {
      this.$router.push('/tmpl/demo/new-demo')
    },
    // 批量删除并刷新列表
    handleDelSelected () {
      this.delList(this.idArrSelected)
    },
    handleExport () {
      console.log('导出', this.idArrSelected)
    },
    handlePrev () {
      console.log('上一页')
    },
    handleNext () {
      console.log('下一页')
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.getList()
    },
    handleCurrentChange (val) {
      // 跳转翻页都会调这个方法
      this.pageNoCode = val
      this.getList()
    },
    // 高级搜索多字段
    onSubmitMulti (obj) {
      this.formData = obj
      this.pageNoCode = 1
      this.getList()
    },
    // 高级搜索单字段
    onSubmitSingle (obj) {
      this.formData = obj
      this.pageNoCode = 1
      this.getList()
    },
    // 高级搜索展开按钮
    searchShow () {
      this.isShowVal = !this.isShowVal
      this.isShow = !this.isShow
    },
    // 数据请求
    getList () {
      const obj = {
        demoName: this.formData.demoName,
        pageNo: this.pageNoCode,
        userName: this.formData.userName,
        pageSize: 10,
        isShowLoading: true
      }
      getList(obj).then(res => {
        console.log('resresresres', res)
        this.tableData = res.data.data.rows
        this.totalNum = res.data.data.recordsTotal
        this.pageNoCode = res.data.data.pageNo // 当前页
      }).catch(e => {
        console.log(e)
      })
    },
    delList (arr) {
      console.log(45)
      delList({
        demoIds: arr,
        isShowLoading: true
      }).then(res => {
        console.log('接收的表格参数', res)
        this.$message({
          message: '删除成功',
          type: 'success',
          // duration: 3000,
          showClose: true,
          offset: document.body.clientHeight / 2 - 21
        })
        this.getList()
        this.isSelection = false
      }).catch(e => {
        console.log(e)
      })
    },
    handleCheckAllChange (val) {
      this.isIndeterminate = false
      const arr = []
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].demoId)
      }
      this.idArrSelected = arr
      if (val.length) {
        this.isSelection = true
      } else {
        this.isSelection = false
      }
      if (typeof val === 'boolean') {
        if (val) {
          console.log('xxxxxx', this.toggleSelection)
          this.toggleSelection(this.tableData)
        } else {
          this.toggleSelection([])
        }
      } else {
        this.checkAll = val.length !== 0
      }
    },
    handleCheckChange (val) {
      const arr = []
      for (let i = 0; i < val.length; i++) {
        arr.push(val[i].demoId)
      }
      this.idArrSelected = arr
      if (val.length) {
        this.isSelection = true
      } else {
        this.isSelection = false
      }
      if (val.length > 0 && val.length < 2) {
        this.isIndeterminate = true
      } else if (val.length === 2) {
        this.checkAll = true
        this.isIndeterminate = false
      } else {
        this.checkAll = false
        this.isIndeterminate = false
      }
    },
    toggleSelection (rows) {
      console.log('ttttttt', this.$refs.multipleTable)
      this.$refs.multipleTable.clearSelection()
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      }
    },
    renderLastHeader (h, { column, $index }) {
      column.minWidth = 55
      column.realWidth = 55
      return h('span', {}, [
        h('svg-icon', {
          props: {
            iconClass: 'setup'
          },
          on: {
            click: () => {
              this.showPopoverPanel()
            }
          },
          slot: 'reference'
        })
      ])
    },
    showPopoverPanel () {
      this.popoverShow = !this.popoverShow
    }

  },
  computed: {}
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/variables";

  .demo-list {
    // 本页面的样式写在这里面
    .multifunctional-table-wrapper {
    }
  }
</style>
